module.exports = __webpack_public_path__ + "img/comm2.26bde944.webp";